import type { PropsWithChildren } from 'react';

// ----------------------------------------------------------------------

export type GuestGuardProps = PropsWithChildren<{}>;

export function GuestGuard({ children }: GuestGuardProps) {
  // Component is left as a placeholder in case logic
  // is desired for these public paths in the future.

  return <>{children}</>;
}
